import type { MovementType, PlayerId } from "@dailywars/core/engine";
import { Car, Footprints, Plane } from "lucide-react";

import { PLAYER_COLORS } from "#/game/playerColors";

type MovementHudIconProps = {
  movementType: MovementType;
  owner: PlayerId;
  className?: string;
};

const ICONS = {
  foot: Footprints,
  vehicle: Car,
  air: Plane,
} as const;

export const MOVEMENT_TYPE_LABEL: Record<MovementType, string> = {
  foot: "Foot units",
  vehicle: "Vehicle units",
  air: "Air units",
};

export function MovementHudIcon({ movementType, owner, className }: MovementHudIconProps) {
  const Icon = ICONS[movementType];
  return (
    <Icon
      className={`h-4 w-4 shrink-0 ${className ?? ""}`}
      style={{ color: PLAYER_COLORS[owner] }}
      aria-hidden
    />
  );
}
